export default __webpack_public_path__ + "static/media/beliveOpen.1abb0441.png";